import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ActiveModal } from '@frontend/sports/modal/feature';

@Component({
    selector: 'ms-earlypayout-tac',
    templateUrl: 'tac-dialog.html',
    standalone: true,
})
export class MyBetsEarlyPayoutTacDialogComponent {
    activationInformation: SafeHtml;

    constructor(
        public sitecore: Sitecore,
        private domSanitizer: DomSanitizer,
        private activeModal: ActiveModal,
    ) {
        this.activationInformation = this.domSanitizer.bypassSecurityTrustHtml(this.sitecore.earlyPayoutV2.ActivationInformation);
    }

    acceptTac(): void {
        this.activeModal.close(true);
    }
}
